import { TaskStatusIcon } from "../../common/styles/Form.styles";
import { SmallText } from "../../common/styles/Text.styles";
import {
  perelynCaramel,
  perelynDarkBlue,
  perelynError,
  perelynLightBlue,
  perelynLightYellow,
  perelynMediumCaramel,
  perelynMediumGreen,
  perelynMediumRed,
  perelynSuccess,
  perelynWarning,
} from "../../styles/consts";
import { capitalizeFirstLetter } from "../../utils";

const colorLookup = {
  green: {
    background: perelynMediumGreen,
    text: perelynSuccess,
  },
  yellow: {
    background: perelynLightYellow,
    text: perelynWarning,
  },
  blue: {
    background: perelynLightBlue,
    text: perelynDarkBlue,
  },
  red: {
    background: perelynMediumRed,
    text: perelynError,
  },
  caramel: {
    background: perelynMediumCaramel,
    text: perelynCaramel,
  },
  orange: {
    background: "#ffe8cc",
    text: "#e67e22",
  },
  darkOrange: {
    background: "#FFD8A8",
    text: "#D84315",
  },
  aqua: {
    background: "#d7ebf0",
    text: "#0788D0",
  },
  copper: {
    background: "#f4d8d8",
    text: "#BB3434",
  },
  grey: {
    background: "#e8e8e8",
    text: "#6b6b6b",
  },
};

const statusColorMapping = {
  matched: "yellow",
  filtered: "darkOrange",
  consultant_review: "green",
  supervisor_review: "aqua",
  approved: "copper",
  sent: "blue",
  rejected: "caramel",
  timed_out: "grey",
  completed: "green",
  viewed: "green",
  candidate_confirmed: "aqua",
  supervisor_confirmed: "copper",
};

export default function MatchStatus({ status }: { status: string }) {
  const getLabel = (status: string) => {
    switch (status) {
      case "matched":
        return "Matched";
      case "consultant_review":
        return "Consultant review";
      case "supervisor_review":
        return "Supervisor review";
      case "approved":
        return "Approved";
      case "timed_out":
        return "Timed out";
      // Legacy status mapping for backward compatibility
      case "completed":
        return "Consultant review";
      case "viewed":
        return "Consultant review";
      case "candidate_confirmed":
        return "Supervisor review";
      case "supervisor_confirmed":
        return "Approved";
      default:
        return capitalizeFirstLetter(status.toLowerCase().replaceAll("_", " "));
    }
  };

  const ts = {
    label: getLabel(status),
    color: statusColorMapping[status] || "yellow",
  };

  return (
    <TaskStatusIcon
      sx={{
        backgroundColor: colorLookup[ts.color].background,
        opacity: 0.9,
      }}
    >
      <SmallText
        id="status"
        sx={{
          whiteSpace: "nowrap",
          color: colorLookup[ts.color].text,
          minWidth: "3rem",
          textAlign: "center",
          padding: "0 0.5rem",
        }}
      >
        {ts.label}
      </SmallText>
    </TaskStatusIcon>
  );
}
